import { createApiRef } from '@backstage/core-plugin-api';
import {
  DefectDojoProduct,
  Finding,
  Engagement,
  PaginatedResponse,
  PaginationParams,
} from '../utils/types';

export interface DefectDojoApi {
  getProduct(productId: number): Promise<DefectDojoProduct>;
  getFindings(
    productId: number,
    params?: PaginationParams,
  ): Promise<PaginatedResponse<Finding>>;
  getEngagements(
    productId: number,
    params?: PaginationParams,
  ): Promise<PaginatedResponse<Engagement>>;
}

export const defectDojoApiRef = createApiRef<DefectDojoApi>({
  id: 'plugin.defect-dojo.api',
});
